module.exports = __webpack_public_path__ + "static/media/test1 (22).79eb9b54.jpg";